export default __webpack_public_path__ + "static/media/jessica-testimonial.23cc24a9.png";